import { useNavigate } from "react-router-dom";

const ButtonIcon = ({ btnText, Icon, size, onclick, nav, disabled }) => {
  const navigate = useNavigate();
  return (
    <button
      disabled={disabled}
      className={`flex-center-align bg-button-bg text-white h-full py-1 px-2 font-poppins text-xs rounded-md hover:bg-hover-bg`}
      onClick={nav ? () => navigate(nav) : onclick}
    >
      <Icon size={size} />
      <span className="pl-1">{btnText}</span>
    </button>
  );
};

export default ButtonIcon;
